export default "__VITE_ASSET__84977eab__"